import { DeleteOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import React from 'react';
import { Props } from '.';
import Icon from '../../../../components/icon/Icon';
import {
    ChallengeRequest,
    EventChallengeVm,
    EventVm,
    UpdateEventCommand,
} from '../../../../utils/api';

class Challenge extends React.PureComponent<Props> {
    public setOutcome = (isSuccessful: boolean): void => {
        const { event, updateEvent } = this.props;

        const eventVm = event as EventVm;
        const ch = event.challenge as EventChallengeVm | undefined;

        const updatedEvent = new UpdateEventCommand({
            ...event,
            challenge: new ChallengeRequest({
                id: ch?.id ?? eventVm.challengeId ?? 0,
                teamId: event.challenge!.teamId,
                isSuccessful,
            }),
        });

        updatedEvent.id = event.id;

        updateEvent(updatedEvent);
    };

    public render = (): React.ReactElement => {
        const { event, isHomeTeam, clearEvent, deleteEvent } = this.props;
        const eventVm = event as EventVm;
        const eventExists = !!eventVm.id;

        const outcome = event.challenge?.isSuccessful;

        const pill = (label: string, active: boolean, onClick: () => void): React.ReactElement => (
            <span
                className={`c-shot-pill${active ? ' c-shot-pill--active' : ''}`}
                onClick={onClick}
                role="button"
            >
                {label}
            </span>
        );

        return (
            <div className="event-create">
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        marginBottom: 8,
                    }}
                >
                    <div className="title" style={{ fontSize: 16 }}>
                        Video challenge — {isHomeTeam ? 'home' : 'away'} team
                    </div>
                    <div className="c-shot-form__actions">
                        <span
                            className="c-shot-form__action-btn"
                            onClick={(): void => clearEvent()}
                            role="button"
                            title="Close"
                        >
                            <Icon name="icon-times" />
                        </span>
                        {eventExists && (
                            <Popconfirm
                                title="Are you sure you want to delete this event?"
                                onConfirm={(): void => deleteEvent(eventVm)}
                                okText="Delete"
                                okButtonProps={{ danger: true }}
                                cancelText="Cancel"
                            >
                                <span
                                    className="c-shot-form__action-btn c-shot-form__action-btn--delete"
                                    role="button"
                                    title="Delete"
                                >
                                    <DeleteOutlined />
                                </span>
                            </Popconfirm>
                        )}
                    </div>
                </div>
                <div className="c-shot-form__grid">
                    <div className="c-shot-form__col" style={{ flexDirection: 'row', gap: 8 }}>
                        {pill('Successful', outcome === true, (): void => this.setOutcome(true))}
                        {pill('Unsuccessful', outcome === false, (): void =>
                            this.setOutcome(false)
                        )}
                    </div>
                </div>
            </div>
        );
    };
}

export default Challenge;
